export const Icons = {
  addWallIcon: require('./Sidebar/Room/AddWallIcon.png'),
  adobe_stock_icon: require('./folder_icons/adobeStock.png'),
  adobe_sign_in_icon: require('./premiumContentLogin/adobe_stock.png'),
  align: require('./centerIcon.png'),
  align_selected: require('./Toolbar/Highlighted/AlignCenterHoverx1.png'),
  align_disabled: require('./Toolbar/Inactive/AlignCenterDisablex1.png'),
  alignBottomDefault: require('./Toolbar/Inactive/AlignBottomDefaultx1.png'),
  alignCenterDefault: require('./Toolbar/Inactive/AlignCenterDefaultx1.png'),
  alignLeftDefault: require('./Toolbar/Inactive/AlignLeftDefaultx1.png'),
  alignMiddleDefault: require('./Toolbar/Inactive/AlignMiddleDefaultx1.png'),
  alignRightDefault: require('./Toolbar/Inactive/AlignRightDefaultx1.png'),
  alignTopDefault: require('./Toolbar/Inactive/AlignTopDefaultx1.png'),
  alignBottomHover: require('./Toolbar/Highlighted/AlignBottomHoverx1.png'),
  alignCenterHover: require('./Toolbar/Highlighted/AlignCenterHoverx1.png'),
  alignLeftHover: require('./Toolbar/Highlighted/AlignLeftHoverx1.png'),
  alignMiddleHover: require('./Toolbar/Highlighted/AlignMiddleHoverx1.png'),
  alignRightHover: require('./Toolbar/Highlighted/AlignRightHoverx1.png'),
  alignTopHover: require('./Toolbar/Highlighted/AlignTopHoverx1.png'),
  arrow_mywork: require('./arrows/arrow4.png'),
  arrow_next: require('./arrows/Final_Check_Arrow.png'),
  arrow_settings: require('./arrows/arrow3.png'),
  arrow_sidebar: require('./arrows/Browse_Choose_Arrow.png'),
  back: require('./back.png'),
  arrow_left_rip: require('./arw_left.png'),
  background: require('./backgroundIcon.png'),
  blockchain_white_icon: require('./blockchain_white_icon.png'),
  bringToFront: require('./Toolbar/Regular/BringToFront_regular.png'),
  bringToFront_selected: require('./Toolbar/Highlighted/Bringfront-aHover.png'),
  bringToFront_disabled: require('./Toolbar/Inactive/Bringfront-inactive.png'),
  caldera: require('./caldera.png'),
  clearAll: require('./Toolbar/Regular/2Dtoolbar-clear.png'),
  clearAll_selected: require('./Toolbar/Highlighted/2Dtoolbar-clear-aHover.png'),
  clearAll_disabled: require('./Toolbar/Inactive/2Dtoolbar-clear-inactive.png'),
  clearColorImage: require('./ClearColorImage.png'),
  close: require('./close.png'),
  closeDefault: require('./CloseDefault.png'),
  closeHover: require('./CloseHover.png'),
  clearDesign: require('./clearDesign_Icon.png'),
  colorGate: require('./colorGate.png'),
  congratsIcon: require('./premiumContentLogin/CongratsIcon.png'),
  covidDefaultIcon: require('./covid19Default.png'),
  covidSelectedIcon: require('./covid19Selected.png'),
  darkContrast: require('./darkContrast.png'),
  delete: require('./Toolbar/Regular/2Dtoolbar-Delete.png'),
  delete_selected: require('./Toolbar/Highlighted/2Dtoolbar-Delete-aHover.png'),
  delete_disabled: require('./Toolbar/Inactive/2Dtoolbar-Delete-inactive.png'),
  down_arrow: require('./down_arrow.png'),
  done_button: require('./DoneIcon.png'),
  downloadAppStoreBadge: require('./download-app-store-badge.png'),
  downloadPlayStoreBadge: require('./download-play-store-badge.png'),
  downArrow: require('./downArrow.png'),
  dreamstime_icon: require('./folder_icons/dreamstime.png'),
  dreamstime_login_logo_lite: require('./premiumContentLogin/dreamstimeIcon.png'),
  dreamstime_login_icon: require('./premiumContentLogin/dreamstimeRegister.png'),
  dropBox: require('./dropboxIcon.png'),
  dropboxIcon_default: require('./UploadContentIcons/dropboxIconUploadDefault.png'),
  dropboxIcon_highlight: require('./UploadContentIcons/dropboxIconUploadActive.png'),
  dropBoxUploadIcon: require('./UploadContentIcons/dropboxIcon.png'),
  duplicate: require('./Toolbar/Regular/Duplicate.png'),
  duplicate_selected: require('./Toolbar/Highlighted/Duplicate-aHover.png'),
  duplicate_disabled: require('./Toolbar/Inactive/Duplicate-inactive.png'),
  ergosoft: require('./ergosoft.png'),
  facebook: require('./facebook.png'),
  facebook_default: require('./facebookDefault.png'),
  facebook_hover: require('./FacebookHover.png'),
  editIcon: require('./premiumContentLogin/edit_icon.png'),
  editBlue: require('./editBlue.png'),
  expand: require('./bootomToolbar/expand.png'),
  fixturesIcon: require('./Sidebar/Room/FixturesIconDefault.png'),
  fixturesIconSelected: require('./Sidebar/Room/FixturesIconHover.png'),
  flip: require('./Toolbar/Regular/2Dtoolbar-Flip.png'),
  flip_selected: require('./Toolbar/Highlighted/2Dtoolbar-Flip-aHover.png'),
  flip_disabled: require('./Toolbar/Inactive/2Dtoolbar-Flip-inactive.png'),
  fotolia_icon: require('./folder_icons/fotoliaImage.png'),
  furnitureIcon: require('./Sidebar/Room/FurnitureIconDefault.png'),
  furnitureIconSelected: require('./Sidebar/Room/FurnitureIconHover.png'),
  galleryImage1: require('./gallery/01.jpg'),
  galleryImage2: require('./gallery/02.jpg'),
  galleryImage3: require('./gallery/03.jpg'),
  galleryImage4: require('./gallery/04.jpg'),
  galleryImage5: require('./gallery/05.jpg'),
  galleryImage6: require('./gallery/06.jpg'),
  gettty_Icon: require('./folder_icons/gettyImages.png'),
  grid: require('./bootomToolbar/grid.png'),
  group_all: require('./Toolbar/Regular/2Dtoolbar-group.png'),
  group_all_selected: require('./Toolbar/Highlighted/2Dtoolbar-group-aHover.png'),
  group_all_disabled: require('./Toolbar/Inactive/2Dtoolbar-group-inactive.png'),
  headerExport: require('./topBar/Header-Export.png'),
  headerHelp: require('./topBar/Header-Help.png'),
  headerMywork: require('./topBar/Header-Mywork.png'),
  headerRedoInactive: require('./Header-Redo-inactive.png'),
  headerRedo: require('./Header-Redo.png'),
  headerSave: require('./topBar/Header-Save.png'),
  headerUndoInactive: require('./Header-Undo-inactive.png'),
  headerUndo: require('./Header-Undo.png'),
  hpCilck: require('./hpClick.png'),
  hpPartnerHeaderLogo: require('./hp_partner_header_logo_v4.png'),
  hpSmartStream: require('./hpSmartStream.png'),
  InfoDefault: require('./InfoDefault.png'),
  infohelpIcon: require('./InfohelpIcon.png'),
  InfoHover: require('./InfoHover.png'),
  inspiration: require('./inspirationIconActive.png'),
  instagramIcon_default: require('./UploadContentIcons/instagramIconUploadDefault.png'),
  instagramIcon_highlight: require('./UploadContentIcons/instagramIconUploadActive.png'),
  icon_warning: require('./icon-Warning.png'),
  istock_icon: require('./folder_icons/istock_images.png'),
  left_arrow: require('./leftArrowBlack.png'),
  linkedin: require('./linkedin.png'),
  linkedin_default: require('./LInkedinDefault.png'),
  linkedin_hover: require('./LInkedinHover.png'),
  light_bulb: require('./Sidebar/AI off.png'),
  light_bulb_active: require('./Sidebar/AI ON.png'),
  light_contrast: require('./LigthContrast.png'),
  loading: require('./loading.gif'),
  lock: require('./Toolbar/Regular/2Dtoolbar-Lock.png'),
  lock_selected: require('./Toolbar/Highlighted/2Dtoolbar-Lock-aHover.png'),
  lock_disabled: require('./Toolbar/Inactive/2Dtoolbar-Lock-inactive.png'),
  mail: require('./mail.png'),
  myContent: require('./myContentIcon.png'),
  material: require('./MaterialIcon.png'),
  martina: require('./Martina.jpg'),
  materialDefault: require('./MaterialIconDefault.png'),
  materialHover: require('./MaterialIconHover.png'),
  next_arrow_blue: require('./arrows/baseline-arrow_forward_ios-24px.png'),
  laptop_icon: require('./laptop/Group_532.png'),
  object: require('./Sidebar/object.png'),
  objectActive: require('./Sidebar/objectsOn.png'),
  objects: require('./objectsIcon.png'),
  pattern_design_icon: require('./folder_icons/pattern_design.png'),
  pattern_design: require('./premiumContentLogin/pattern_design_icon.png'),
  photo: require('./Sidebar/photos OFF.png'),
  photoActive: require('./Sidebar/photos ON.png'),
  photos: require('./photosIcon.png'),
  pinterest: require('./pinterest.png'),
  pinterest_default: require('./PinterestDefault.png'),
  pinterest_hover: require('./PinterestHover.png'),
  patternDesignTitleImage: require('./premiumContentLogin/PatternDesignRegister.png'),
  patternDesignRegister: require('./premiumContentLogin/PDRegisterImage.png'),
  pixelation_warning_close_dark: require('./Pixelation-warning/x.png'),
  pixelation_warning_close_default: require('./Pixelation-warning/CloseDefault.png'),
  pixelation_warning_close_hover: require('./Pixelation-warning/CloseHover.png'),
  pixelation_warning_icon: require('./Pixelation-warning/icon-Warning.png'),
  pixelation_warning_icon_black: require('./Pixelation-warning/icon-Warning-black.png'),
  plus: require('./plus.png'),
  premiumContentThumb: require('./premiumContentLogin/PremiumContentThumb.png'),
  premiumBadge: require('./premiumBadge.png'),
  previous_disabled: require('./arrows/backDisabled.png'),
  previous_enabled: require('./arrows/previous.png'),
  previewNavigateLeft: require('./scroll_left.png'),
  previewNavigateRight: require('./scroll_right.png'),
  previewNormal: require('./topBar/PreviewNormal.png'),
  printFactory: require('./printFactory.png'),
  processing_icon: require('./processing.gif'),
  right_arrow: require('./right_arrow.png'),
  right_arrow2: require('./rightArrowBack.png'),
  recolor: require('./Toolbar/Regular/RecolorDefault.png'),
  recolor_selected: require('./Toolbar/Highlighted/RecolorHover.png'),
  recolor_disabled: require('./Toolbar/Inactive/RecolorInactive.png'),
  resize_arbitrarily: require('./Toolbar/Regular/2Dtoolbar-scale-arbitrarily.png'),
  resize_arbitrarily_selected: require('./Toolbar/Highlighted/2Dtoolbar-scale-arbitrarily-aHover.png'),
  resize_arbitrarily_disabled: require('./Toolbar/Inactive/2Dtoolbar-scale-arbitrarily-inactive.png'),
  resize_proportionally: require('./Toolbar/Regular/Resize-proportionally.png'),
  resize_proportionally_selected: require('./Toolbar/Highlighted/Resize-proportionally-aHover.png'),
  resize_proportionally_disabled: require('./Toolbar/Inactive/Resize-proportionally-inactive.png'),
  roomIcon: require('./Sidebar/MyRoomIcon.png'),
  roomWallCeilingLeftShadow: require('./RoomWall/ceiling_left_shadow.png'),
  roomWallCeilingShadow: require('./RoomWall/ceiling_mid_shadow.png'),
  roomWallCeilingRightShadow: require('./RoomWall/ceiling_right_shadow.png'),
  roomWallWallLeftShadow: require('./RoomWall/wall_left_shadow.png'),
  roomWallWallRightShadow: require('./RoomWall/wall_right_shadow.png'),
  roomWallFloor: require('./RoomWall/Designer-floor.jpg'),
  roomWallFloorLeftShadow: require('./RoomWall/FloorLeft_shadow.png'),
  roomWallFloorRightShadow: require('./RoomWall/FloorRight_shadow.png'),
  rotate: require('./Toolbar/Regular/2Dtoolbar-Rotate.png'),
  rotate_selected: require('./Toolbar/Highlighted/2Dtoolbar-Rotate-aHover.png'),
  rotate_disabled: require('./Toolbar/Inactive/2Dtoolbar-Rotate-inactive.png'),
  sai: require('./sai.png'),
  scale: require('./Toolbar/Regular/2Dtoolbar-Scale.png'),
  scale_selected: require('./Toolbar/Highlighted/2Dtoolbar-Scale-aHover.png'),
  scale_disabled: require('./Toolbar/Inactive/2Dtoolbar-Scale-inactive.png'),
  scaleAll: require('./Toolbar/Regular/2Dtoolbar-scaleAll.png'),
  scaleAll_selected: require('./Toolbar/Highlighted/2Dtoolbar-scaleAll-aHover.png'),
  scaleAll_disabled: require('./Toolbar/Inactive/2Dtoolbar-scaleAll-inactive.png'),
  scaleToFit: require('./Toolbar/Regular/2Dtoolbar-scaletofit.png'),
  scaleToFit_selected: require('./Toolbar/Highlighted/2Dtoolbar-scaletofit-aHover.png'),
  scaleToFit_disabled: require('./Toolbar/Inactive/2Dtoolbar-scaletofit-inactive.png'),
  search: require('./searchIconActive.png'),
  searchClose: require('./searchClose.png'),
  searchDefault: require('./searchIconDefault.png'),
  searchBlack: require('./searchBlack.png'),
  sendToBack: require('./Toolbar/Regular/SendToBack_regular.png'),
  sendToBack_selected: require('./Toolbar/Highlighted/BringBack-aHover.png'),
  sendToBack_disabled: require('./Toolbar/Inactive/BringBack-inactive.png'),
  setting: require('./Sidebar/settingsOff.png'),
  settingActive: require('./Sidebar/settingsOn.png'),
  settings: require('./settingsIcon.png'),
  signedinContentProvidersIcon: require('./premiumContentLogin/SignedinContentProvidersIcon.png'),
  spinner_small: require('./spinner_small.gif'),
  stretch: require('./Toolbar/Regular/2Dtoolbar-scaletofit.png'),
  stretch_selected: require('./Toolbar/Highlighted/2Dtoolbar-scaletofit-aHover.png'),
  stretch_disabled: require('./Toolbar/Inactive/2Dtoolbar-scaletofit-inactive.png'),
  unstretch: require('./Toolbar/Regular/2Dtoolbar-scaletofit.png'),
  unstretch_selected: require('./Toolbar/Highlighted/2Dtoolbar-scaletofit-aHover.png'),
  unstretch_disabled: require('./Toolbar/Inactive/2Dtoolbar-scaletofit-inactive.png'),
  templates: require('./templatesIcon.png'),
  text: require('./textIcon.png'),
  textOn: require('./Sidebar/textOn.png'),
  textOff: require('./Sidebar/textOff.png'),
  tile: require('./Toolbar/Regular/2Dtoolbar-Tile.png'),
  tile_selected: require('./Toolbar/Highlighted/2Dtoolbar-Tile-aHover.png'),
  tile_disabled: require('./Toolbar/Inactive/2Dtoolbar-Tile-inactive.png'),
  thumbs_down: require('./thumbsDown.png'),
  thumbs_up: require('./thumbsUp.png'),
  transparency: require('./Toolbar/Regular/TransparencyIconx2.png'),
  transparency_selected: require('./Toolbar/Highlighted/TransparencyIconHoverx2.png'),
  transparency_disabled: require('./Toolbar/Regular/TransparencyIconx2.png'),
  twitter: require('./twitter.png'),
  twitter_default: require('./TwitterDefault.png'),
  twitter_hover: require('./TwitterHover.png'),
  unlock: require('./Toolbar/Regular/2Dtoolbar-unlock.png'),
  unlock_selected: require('./Toolbar/Highlighted/2Dtoolbar-unlock-aHover.png'),
  unlock_disabled: require('./Toolbar/Inactive/2Dtoolbar-unlock-inactive.png'),
  unsplash_icon: require('./folder_icons/unsplashImage.png'),
  untile: require('./Toolbar/Regular/untile.png'),
  unix: require('./onyx.png'),
  untile_selected: require('./Toolbar/Highlighted/untile-aHover.png'),
  untile_disabled: require('./Toolbar/Inactive/untile-inactive.png'),
  up_arrow: require('./up_arrow.png'),
  upload: require('./UploadButton.png'),
  upload1: require('./Sidebar/upload.png'),
  uploadActive: require('./Sidebar/uploadActive.png'),
  upload_logo_giftwraps_default: require('./UploadContentIcons/UploadLogoDefault.png'),
  upload_logo_giftwraps_hover: require('./UploadContentIcons/UploadLogoHover.png'),
  upArrow: require('./upArrow.png'),
  userIconBlue: require('./topBar/user_icon_blue.png'),
  vecteezy_icon: require('./folder_icons/vecteezyimage.png'),
  warning_icon: require('./WarningIcon.png'),
  vecteezy_login_logo_lite: require('./premiumContentLogin/vecteezy_login_logo_lite.png'),
  vecteezy_logo_icon: require('./premiumContentLogin/vecteezy_logo_icon.jpg'),
  vecteezy_register_icon: require('./premiumContentLogin/Vecteezy_Register_Image.png'),
  zoom_icon: require('./zoomIcon.png'),
  zoomIcon: require('./Toolbar/Regular/zoom-regular.png'),
  zoom_icon_selected: require('./Toolbar/Highlighted/zoom-hover.png'),
  zoom_icon_disabled: require('./Toolbar/Inactive/zoom-inactive.png'),
  zoom_in: require('./Toolbar/Regular/zoom-in-regular.png'),
  zoom_out: require('./Toolbar/Regular/zoom-out-regular.png'),
  zoom_in_selected: require('./Toolbar/Highlighted/zoom-in-hover.png'),
  zoom_out_selected: require('./Toolbar/Highlighted/zoom-out-hover.png'),
  zoom_in_disabled: require('./Toolbar/Inactive/zoom-in-inactive.png'),
  zoom_out_disabled: require('./Toolbar/Inactive/zoom-out-inactive.png'),
  content_show: require('./hamburgerMenu.png'),
  threeDVisualizeIcon: require('./SwitchIcons/3DView.png'),
  twoDVisualizeIcon: require('./SwitchIcons/2DView.png'),
  threeD_icon_selected: require('./SwitchIcons/threeD_icon.png'),
  threeD_icon_disabled: require('./SwitchIcons/threeD_icon_disabled.png'),
  sticker_edit_icon: require('./SwitchIcons/EditIcon.png'),
  sticker_visualize_icon: require('./SwitchIcons/ViewIcon.png'),
  next_disabled: require('./arrows/nextDisabled.png'),
  next_enabled: require('./arrows/next.png'),
  next_arrow_white: require('./arrows/baseline-arrow_forward_ios-3.png'),
  prev_arrow_white: require('./arrows/Group_525.png'),
  next_arrow_disable: require('./arrows/next_arrow_disable.png'),
  seria_number_info: require('./serial_number_info.png'),
  navigationArrowLeft: require('./WallNavigation/Left.png'),
  navigationArrowLeftSelected: require('./WallNavigation/Left_hover.png'),
  navigationArrowRight: require('./WallNavigation/Right.png'),
  navigationArrowRightSelected: require('./WallNavigation/Right_hover.png'),
  multiCanvasDesigner: require('./MultiCanvasDesigner.png'),
  multiCanvasDesignerCustom: require('./MulticanvasDesignerCustom.png'),
  canvasFrameTypeExtend: require('./canvas_frame_type_extend.png'),
  canvasFrameTypeMirror: require('./canvas_frame_type_mirror.png'),
  canvasFrameTypeSolidColor: require('./canvas_frame_type_solid_color.png'),
  finishingIconDefault: require('./FinishingIconDefault.png'),
  finishingIconHover: require('./FinishingIconHover.png'),
  editDefault: require('./Edit_Default.png'),
  leftBlackArrow: require('./CommonIcons/Arrow_Left.png'),
  rightBlackArrow: require('./CommonIcons/Arrow_Right.png'),
  downBlackArrow: require('./CommonIcons/Arrow_Down.png'),
  upBlackArrow: require('./CommonIcons/Arrow_Up.png'),
  stickerNewEditMode: require('./sticker_icons/EditModePlusButton.png'),
  stickerNewVisualizeMode: require('./sticker_icons/VisualizaModePlusButton.png'),
  stickersAppIcon: require('./ModelPage/StickersDesigner.png'),
  magnetsAppIcon: require('./ModelPage/MagnetsDesigner.png'),
  stickerAppThumnailNotebookNormal: require('./stickerVisualizeBackground/stickerApp/EnviroNotebookIconOff.png'),
  stickerAppThumnailNotebookSelected: require('./stickerVisualizeBackground/stickerApp/EnviroNotebookIconOn.png'),
  stickerAppBackgroundNotebook: require('./stickerVisualizeBackground/stickerApp/NotepadEnviro.jpg'),
  stickerAppThumnailLaptopNormal: require('./stickerVisualizeBackground/stickerApp/EnviroLaptopIconOff.png'),
  stickerAppThumnailLaptopSelected: require('./stickerVisualizeBackground/stickerApp/EnviroLaptopIconOn.png'),
  stickerAppBackgroundLaptop: require('./stickerVisualizeBackground/stickerApp/LaptopEnviroDesigner.jpg'),
  stickerAppThumnailLockerNormal: require('./stickerVisualizeBackground/stickerApp/EnviroLockerIconOff.png'),
  stickerAppThumnailLockerSelected: require('./stickerVisualizeBackground/stickerApp/EnviroLockerIconOn.png'),
  stickerAppBackgroundLocker: require('./stickerVisualizeBackground/stickerApp/LockerEnviroDesigner.jpg'),
  magnetAppThumnailLockerNormal: require('./stickerVisualizeBackground/magnetApp/EnviroLockerIconOff.png'),
  magnetAppThumnailLockerSelected: require('./stickerVisualizeBackground/magnetApp/EnviroLockerIconOn.png'),
  magnetAppBackgroundLocker: require('./stickerVisualizeBackground/magnetApp/LockerEnviroDesigner.jpg'),
  magnetAppThumnailFridgeNormal: require('./stickerVisualizeBackground/magnetApp/EnviroFridgeIconOff.png'),
  magnetAppThumnailFridgeSelected: require('./stickerVisualizeBackground/magnetApp/EnviroFridgeIconOn.png'),
  magnetAppBackgroundFridge: require('./stickerVisualizeBackground/magnetApp/FridgeEnviroDesigner.jpg'),
  magnetAppThumnailBoardNormal: require('./stickerVisualizeBackground/magnetApp/EnviroBoardIconOff.png'),
  magnetAppThumnailBoardSelected: require('./stickerVisualizeBackground/magnetApp/EnviroBoardIconOn.png'),
  magnetAppBackgroundBoard: require('./stickerVisualizeBackground/magnetApp/MagneticBoardEnviroDesigner.jpg'),
  floorAppThumnailArtGalleryNormal: require('./stickerVisualizeBackground/floorApp/EnviroArtGalleryIconOff.png'),
  floorAppThumnailArtGallerySelected: require('./stickerVisualizeBackground/floorApp/EnviroArtGalleryIconOn.png'),
  floorAppBackgroundArtGallery: require('./stickerVisualizeBackground/floorApp/ArtGalleryDesigner.jpg'),
  floorAppThumnailChildroomNormal: require('./stickerVisualizeBackground/floorApp/EnviroChildroomIconOff.png'),
  floorAppThumnailChildroomSelected: require('./stickerVisualizeBackground/floorApp/EnviroChildroomIconOn.png'),
  floorAppBackgroundChildroom: require('./stickerVisualizeBackground/floorApp/ChildRoomDesigner.jpg'),
  floorAppThumnailLivingRoomNormal: require('./stickerVisualizeBackground/floorApp/EnviroLivingroomIconOff.png'),
  floorAppThumnailLivingRoomSelected: require('./stickerVisualizeBackground/floorApp/EnviroLivingroomIconOn.png'),
  floorAppBackgroundLivingRoom: require('./stickerVisualizeBackground/floorApp/LivingRoomDesigner.jpg'),
  floorAppThumnailSupermarketNormal: require('./stickerVisualizeBackground/floorApp/EnviroSupermarketIconOff.png'),
  floorAppThumnailSupermarketSelected: require('./stickerVisualizeBackground/floorApp/EnviroSupermarketIconOn.png'),
  floorAppBackgroundSupermarket: require('./stickerVisualizeBackground/floorApp/SupermarketDesigner.jpg'),
  wallCoveringCustom: require('./WallCovering/customWC.png'),
  wallCoveringLandscape: require('./WallCovering/landscapeWC.png'),
  wallCoveringPortrait: require('./WallCovering/portraitWC.png'),
  wallCoveringSquare: require('./WallCovering/squareWC.png'),
  windowAppThumnailCoffeeshopNormal: require('./stickerVisualizeBackground/windowApp/EnviroCoffeeViewIconOff.png'),
  windowAppThumnailCoffeeshopSelected: require('./stickerVisualizeBackground/windowApp/EnviroCoffeeViewIconOn.png'),
  windowAppBackgroundCoffeeshop: require('./stickerVisualizeBackground/windowApp/CoffeshopEnviro.jpg'),
  windowAppThumnailFashionstoreNormal: require('./stickerVisualizeBackground/windowApp/EnviroFashionIconOff.png'),
  windowAppThumnailFashionstoreSelected: require('./stickerVisualizeBackground/windowApp/EnviroFashionIconOn.png'),
  windowAppBackgroundFashionstore: require('./stickerVisualizeBackground/windowApp/FashionStoreEnviro.jpg'),
  windowAppThumnailOfficeNormal: require('./stickerVisualizeBackground/windowApp/EnviroOfficeIconOff.png'),
  windowAppThumnailOfficeSelected: require('./stickerVisualizeBackground/windowApp/EnviroOfficeIconOn.png'),
  windowAppBackgroundOffice: require('./stickerVisualizeBackground/windowApp/OfficeEnviro.jpg'),
  windowAppThumnailDaycareNormal: require('./stickerVisualizeBackground/windowApp/EnviroKindergardenIconOff.png'),
  windowAppThumnailDaycareSelected: require('./stickerVisualizeBackground/windowApp/EnviroKindergardenIconOn.png'),
  windowAppBackgroundDaycare: require('./stickerVisualizeBackground/windowApp/DayCareEnviro.jpg'),
  windowAppStickingSideFront: require('./sticker_icons/WindowGraphicsDesignerFront.png'),
  windowAppStickingSideBack: require('./sticker_icons/WindowGraphicsDesignerBack.png')
};
